import { useEffect, useState } from "react";
import "../component/style.css";
import SideNav from "../component/sideNav";
import Header from "../component/header";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { CompanyApi, UserApi } from "../apis";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  InputAdornment,
  Tooltip,
  FormControl,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InsightsIcon from "@mui/icons-material/Insights";
import EditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Grid from "@mui/material/Grid2";
import CustomInput from "../component/customInput";
import CustomInputLabel from "../component/customInputLabel";

const Customer = () => {
  const [Customers, setCustomers] = useState([]);
  const [paginator, setPaginator] = useState({
    page: 0,
    perPage: 10,
  });
  const [totalCount, setTotalCount] = useState(0);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayEditModal, setDisplayEditModal] = useState(false);
  const [displayDeleteModal, setDisplayDeleteModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const CustomerRouter = UserApi();
  const CompanyRouter = CompanyApi();

  // Attributes
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [companyName, setCompanyName] = useState("");

  const [companyData, setCompanyData] = useState([]);
  const [existingCompany, setExistingCompany] = useState(false);
  const [companyId, setCompanyId] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchCompany, setSearchCompany] = useState("");

  //Err Attributes
  const [nameErr, setNameErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [phoneErr, setPhoneErr] = useState("");
  const [companyNameErr, setCompanyNameErr] = useState("");

  const columns = [
    {
      field: "name",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Name
        </div>
      ),
      flex: 1,
      renderCell: (params) => params?.value,
      sortable: false,
    },
    {
      field: "email",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Email
        </div>
      ),
      flex: 1,
      renderCell: (params) => params?.email,
      sortable: false,
    },
    {
      field: "phone",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Phone Number
        </div>
      ),
      flex: 1,
      renderCell: (params) => params?.phone,
      sortable: false,
    },
    {
      field: "companyName",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Company Name
        </div>
      ),
      flex: 1,
      renderCell: ({ row }) => row.company_id?.name,
      sortable: false,
    },
    {
      field: "projectCount",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          No of Project
        </div>
      ),
      flex: 1,
      renderCell: ({ row }) => row?.projectCount,
      sortable: false,
    },
    {
      field: "updatedAt",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Updated At
        </div>
      ),
      flex: 1,
      renderCell: ({ row }) => {
        const dateString = row?.updatedAt;
        if (!dateString) return "";
        const dateObject = new Date(dateString);
        const formattedDate = dateObject.toISOString().split("T")[0];

        return formattedDate;
      },
      sortable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      getActions: ({ row }) => [
        <GridActionsCellItem
          icon={
            <Tooltip title="Detail" placement="top">
              <InsightsIcon style={{ color: "green", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Detail"
        />,
        <GridActionsCellItem
          icon={
            <Tooltip title="Edit" placement="top">
              <EditIcon style={{ color: "#27326A", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Edit"
          onClick={() => {
            setSelectedRecord(row);
            setName(row?.name);
            setEmail(row?.email);
            setPhone(row?.phone);
            setCompanyName(row?.company_id?.name);
            toggleEditModal();
          }}
        />,
        <GridActionsCellItem
          icon={
            <Tooltip title="Delete" placement="top">
              <DeleteIcon style={{ color: "red", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Delete"
          onClick={() => {
            toggleDeleteModal();
            setSelectedRecord(row?._id);
          }}
        />,
      ],
    },
  ];

  useEffect(() => {
    getAllCustomers();
    // eslint-disable-next-line
  }, [paginator]);

  useEffect(() => {
    getAllCompanies();
    // eslint-disable-next-line
  }, []);

  const toggleAddModal = () => setDisplayAddModal(!displayAddModal);
  const toggleEditModal = () => setDisplayEditModal(!displayEditModal);
  const toggleDeleteModal = () => setDisplayDeleteModal(!displayDeleteModal);

  const getAllCompanies = async () => {
    const CompanyData = await CompanyRouter.getAll();
    setCompanyData(CompanyData.data);
  };

  const getAllCustomers = async ({ search = "", companyID = "" } = {}) => {
    try {
      const res = await CustomerRouter.getAll({
        page: paginator.page,
        pageSize: paginator.pageSize,
        type: "CUSTOMER",
        companyId: companyID,
        search: search,
      });
      if (res?.data) {
        setCustomers(res?.data);
        setTotalCount(res?.pagination?.totalCount);
      }
    } catch (error) {
      console.log("Customers ", error);
    }
  };

  const addCustomer = () => {
    setName();
    setEmail();
    setPhone();
    setCompanyId("");
    setCompanyName("");
    setNameErr("");
    setEmailErr("");
    setPhoneErr("");
    toggleAddModal();
  };

  const createCustomer = async () => {
    try {
      const isValid = validate();
      if (!isValid) return null;

      const submitData = new FormData();

      submitData.append("name", name);
      submitData.append("email", email);
      submitData.append("phone", phone);
      submitData.append("role", "CUSTOMER");

      if (existingCompany) {
        submitData.append("companyId", companyId);
      } else {
        submitData.append("companyName", companyName);
      }

      const res = await CustomerRouter.create(submitData);
      if (res.status !== 201 && res.status !== 200) {
        const msg =
          res?.error?.response?.data?.message || "An unknown Error occured";
        setEmailErr(msg);
      } else {
        toggleAddModal();
        setName("");
        setEmail("");
        setPhone("");
        getAllCustomers();
      }
    } catch (error) {
      console.log("Customers ", error);
    }
  };

  const updateCustomer = async () => {
    try {
      const isValid = validate(true);
      if (!isValid) return null;

      const updateData = new FormData();

      updateData.append("name", name);
      updateData.append("phone", phone);

      if (existingCompany) {
        updateData.append("company_id", companyId);
      } else {
        updateData.append("companyName", companyName);
      }

      const res = await CustomerRouter.update(updateData, selectedRecord?._id);
      if (res) {
        toggleEditModal();
        setName("");
        setEmail("");
        setPhone("");
        setCompanyName("");
        setCompanyId("");
        getAllCustomers();
        getAllCompanies();
      }
    } catch (error) {
      console.log("Customers ", error);
    }
  };

  const removeCustomer = async (id) => {
    try {
      const id = selectedRecord;
      const res = await CustomerRouter.remove(id);
      if (res) {
        getAllCustomers();
        toggleDeleteModal();
      }
    } catch (error) {
      console.log("Customers ", error);
    }
  };

  const validate = (isUpdate = false) => {
    let isValid = true;
    if (!name) {
      setNameErr("name is required");
      isValid = false;
    }

    if (!email && !isUpdate) {
      setEmailErr("email is required");
      isValid = false;
    }

    if (!phone) {
      setPhoneErr("phone no is required");
      isValid = false;
    }

    if (existingCompany && !isUpdate) {
      if (!companyId) {
        alert("Company is Required to select")
        isValid = false;
      }
    } else if (!isUpdate) {
      if (!companyName) {
        setCompanyNameErr("company name is required");
        isValid = false;
      }
    }

    return isValid;
  };

  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const debounceSearch = debounce(getAllCustomers, 500);

  const handleSearchInput = (e) => {
    const search = e.target.value;
    setSearchTerm(search);
    debounceSearch({ search });
  };

  const handleCompanySelect = (e) => {
    const val = e.target.value;
    setSearchCompany(val);
    getAllCustomers({ search: searchTerm, companyID: val });
  };

  return (
    <>
      <div className="mainContainer">
        {/* Add Dialog */}
        <Dialog open={displayAddModal} onClose={toggleAddModal}>
          <DialogTitle>Create Customer</DialogTitle>
          <DialogContent sx={{ maxWidth: "350px" }}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container>
                <CustomInput
                  id="name"
                  name="name"
                  title="Enter name"
                  type="text"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setNameErr("");
                  }}
                  required={nameErr.length > 0 ? true : false}
                  helperText={nameErr}
                  placeholder="enter name"
                  width="100%"
                />
                <CustomInput
                  id="email"
                  name="email"
                  title="Enter email"
                  type="text"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailErr("");
                  }}
                  required={emailErr.length > 0 ? true : false}
                  helperText={emailErr}
                  placeholder="enter email"
                  width="100%"
                />
                <CustomInput
                  id="phone"
                  name="phone"
                  title="Enter phone"
                  type="text"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    setPhoneErr("");
                  }}
                  required={phoneErr.length > 0 ? true : false}
                  helperText={phoneErr}
                  placeholder="enter phone"
                  width="100%"
                />

                <Box sx={{ width: "100%" }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={existingCompany}
                        onChange={(e) => setExistingCompany(e.target.checked)}
                        color="primary"
                      />
                    }
                    label="Select Existing Company"
                  />
                </Box>

                {!existingCompany ? (
                  <CustomInput
                    id="companyName"
                    name="companyName"
                    title="Enter company name"
                    type="text"
                    value={companyName}
                    onChange={(e) => {
                      setCompanyName(e.target.value);
                      setCompanyNameErr("");
                    }}
                    required={companyNameErr.length > 0 ? true : false}
                    helperText={companyNameErr}
                    placeholder="enter company name"
                    width="100%"
                  />
                ) : (
                  <Box sx={{ width: 320 }}>
                    <CustomInputLabel title={"company"} />
                    <FormControl fullWidth>
                      <Select
                        id="demo-simple-select"
                        value={companyId}
                        onChange={(e) => setCompanyId(e.target.value)}
                      >
                        {companyData.map((company) => (
                          <MenuItem value={company._id}>
                            {company.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                )}
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={toggleAddModal}>Cancel</Button>
            <Button onClick={() => createCustomer()}>Create</Button>
          </DialogActions>
        </Dialog>

        {/* Edit Dialog  */}
        <Dialog open={displayEditModal} onClose={toggleEditModal}>
          <DialogTitle>Edit Customer</DialogTitle>
          <DialogContent sx={{ maxWidth: "350px" }}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container>
                <CustomInput
                  id="name"
                  name="name"
                  title="Enter name"
                  type="text"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setNameErr("");
                  }}
                  required={nameErr.length > 0 ? true : false}
                  helperText={nameErr}
                  placeholder="enter name"
                  width="100%"
                />
                <CustomInputLabel title={"Email"} isRequired={false} />
                <TextField
                  value={email}
                  id="email"
                  name="email"
                  fullWidth
                  disabled
                  variant="outlined"
                  sx={{ backgroundColor: "#E9ECEF" }}
                />
                <CustomInput
                  id="phone"
                  name="phone"
                  title="Enter phone"
                  type="text"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    setPhoneErr("");
                  }}
                  required={phoneErr.length > 0 ? true : false}
                  helperText={phoneErr}
                  placeholder="enter phone"
                  width="100%"
                />
                <Box sx={{ width: "100%" }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={existingCompany}
                        onChange={(e) => setExistingCompany(e.target.checked)}
                        color="primary"
                      />
                    }
                    label="Select Existing Company"
                  />
                </Box>

                {!existingCompany ? (
                  <CustomInput
                    id="companyName"
                    name="companyName"
                    title="Enter company name"
                    type="text"
                    value={companyName}
                    onChange={(e) => {
                      setCompanyName(e.target.value);
                      setCompanyNameErr("");
                    }}
                    required={companyNameErr.length > 0 ? true : false}
                    helperText={companyNameErr}
                    placeholder="enter company name"
                    width="100%"
                  />
                ) : (
                  <Box sx={{ width: 320 }}>
                    <CustomInputLabel title={"company"} />
                    <FormControl fullWidth>
                      <Select
                        id="demo-simple-select"
                        value={companyId}
                        onChange={(e) => setCompanyId(e.target.value)}
                      >
                        {companyData.map((company) => (
                          <MenuItem value={company._id}>
                            {company.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                )}
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={toggleEditModal}>Cancel</Button>
            <Button onClick={() => updateCustomer()}>Update</Button>
          </DialogActions>
        </Dialog>

        {/* Delete Dialog */}
        <Dialog open={displayDeleteModal} onClose={toggleDeleteModal}>
          <DialogTitle>DELETE Customer</DialogTitle>
          <DialogContent>
            Are you sure you want to disable/delete this Customer?
            <h3 className="infoAlert">
              *All details will be lost and can not be recovered
            </h3>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={toggleDeleteModal}
              variant="contained"
              sx={{ backgroundColor: "#27326A" }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => removeCustomer()}
              variant="contained"
              sx={{ backgroundColor: "#FF7C1B" }}
            >
              Delete Customer
            </Button>
          </DialogActions>
        </Dialog>

        <Header></Header>
        <SideNav active="Customers" />
        <div className="contentBox">
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "1%",
              marginTop: "1%",
              gap: "20px",
              alignItems: "center",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <Select
                value={searchCompany}
                onChange={(e) => handleCompanySelect(e)}
                displayEmpty
                renderValue={(selectedId) => {
                  const selectedCompany = companyData.find(
                    (c) => c._id === selectedId
                  );
                  return selectedCompany?.name || "Select Company";
                }}
                sx={{ width: "200px" }}
              >
                <MenuItem disabled value="">
                  Select Company
                </MenuItem>
                {companyData.map((company) => (
                  <MenuItem key={company._id} value={company._id}>
                    {company.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <TextField
              label="Search"
              margin="dense"
              variant="outlined"
              id="outlined-start-adornment"
              sx={{ m: 1, width: "25ch" }}
              onChange={handleSearchInput}
              value={searchTerm}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon></SearchIcon>
                    </InputAdornment>
                  ),
                },
              }}
            />
            <Button
              variant="contained"
              size="small"
              style={{
                backgroundColor: "#27326A",
                width: "148px",
                height: "40px",
                textTransform: "none",
              }}
              onClick={() => addCustomer()}
            >
              <AddCircleOutlineIcon
                sx={{ marginRight: "10px", width: 18, height: 18 }}
              />
              Add Customer
            </Button>
          </Box>
          <DataGrid
            sx={{
              borderRadius: 3,
              border: 0,
              width: "100%",
              outline: "none", // Remove blue outline
              ".MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold !important",
                overflow: "visible !important",
                color: "#27326A",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-sortIcon": {
                display: "none !important",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                {
                  outline: "none", // Remove blue outline
                },
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none", // Remove blue outline
              },
              "& .MuiDataGrid-cell": {
                outline: "none", // Remove blue outline from cells
              },
              "& .MuiDataGrid-cell--textLeft": {
                textAlign: "left",
              },
              "& .MuiDataGrid-cell--textCenter": {
                textAlign: "center",
              },
              "& .MuiDataGrid-cell--textRight": {
                textAlign: "right",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "transparent !important",
              },
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "transparent !important",
              },
              "& .MuiDataGrid-row:nth-of-type(even)": {
                backgroundColor: "white",
                boxShadow: "0px 0px 30px #EDEEF4",
                outline: "none",
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                outline: "none",
              },
              "& .name-cell-style": {
                color: "#566477",
                outline: "none",
              },
              "& .default-cell-style": {
                color: "#95A2B4",
                outline: "none",
              },
              "& .MuiDataGrid-row": {
                borderBottom: "none",
                outline: "none",
              },
              "& .MuiDataGrid-columnHeaders": {},
            }}
            disableColumnMenu
            disableSelectionOnClick
            getRowId={(row) => row._id}
            columns={columns}
            rows={Customers}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterExcludeHiddenColumns: true,
                },
              },
              pagination: {
                paginationModel: { page: 0, pageSize: paginator.perPage },
              },
            }}
            paginationMode="server"
            rowCount={totalCount}
            onPaginationModelChange={(newPage) => {
              setPaginator({
                page: newPage?.page,
                perPage: newPage?.pageSize,
              });
            }}
            pageSizeOptions={[10]}
          ></DataGrid>
        </div>
      </div>
    </>
  );
};

export default Customer;
